<template>
<div class="fklist">
   <!--  <div style="width: 7.5rem; height: .8rem; background: #fff;" v-if="showPhoneXS"></div> -->
    <div class="fklist-top">
        <img class="navBack" @click.stop="back()" src="../../../static/images/shootShop/back.png" alt="" >
        <span v-show="typeId == 0">访客列表</span>
        <span v-show="typeId == 1">智能推荐</span>
    </div>
    <div class="fklist-list" v-show="showBox == 1">
        <!-- <mt-loadmore :top-method="loadTop" :bottom-method="loadBottom" @bottom-status-change="handleBottomChange" ref="loadmore" :bottom-all-loaded="allLoaded" :auto-fill="false"> -->
        <mt-loadmore :bottom-method="loadBottom" @bottom-status-change="handleBottomChange" ref="loadmore" :bottom-all-loaded="allLoaded" :auto-fill="false">
            <dl v-for="(item,index) in listArr">
                <p v-if="indexFun(index)" v-show="typeId == 0">{{item.create_time}}</p>
                <p v-if="indexFun(index)" v-show="typeId == 1">{{item.create_time}}<span>您的商铺被推荐给了以下客户</span></p>
                <dt>
                    <img :src="item.head_img" :onerror="defaultImg" />
                    
                    <p v-if="urlType && typeId == 0" class="order-id" :data-clipboard-text="item.accountAll" @click="copyDel">{{item.accountAll}}<span>复制</span></p>
                    <p v-else-if="urlType && typeId == 1" class="order-id" :data-clipboard-text="item.accountAll" @click="copyDel">{{item.complete}}<span>复制</span></p>

                    <span class="span1" v-else>{{item.account}}</span>

                </dt>
                <dd>{{item.type}}</dd>
            </dl>
            <div class="noDataBottom" v-if="more" style=" margin-bottom: 1.8rem;">没有更多数据了...</div>
        </mt-loadmore>
    </div>
    <div v-show="showBox == 0">
        <div class="null-data-box">
            <img src="../../../static/images/home/null-data.png">
            <p>暂无数据</p>
        </div>
    </div>

    <!-- footer -->
    <div class="shopdetail-footer">

        <img :src="customer.image" class="consultant2-img" alt="" v-if="customer.image" :onerror="defaultImg"/>
        <img src="../../../static/images/shopDetail/consultant2.png" alt="" class="consultant2-img" v-else/>

        <ul>
            <li class="li1" @click="goMessageuser();">
                <img src="../../../static/images/shopDetail/footer1-icon.png" alt=""/>
                <span>在线聊</span>
            </li>
            <li class="li2" @click="telPhone()">
                <img src="../../../static/images/shopDetail/footer2-icon.png" alt="" />
                <span>打电话</span>
            </li>
        </ul>
    </div>

</div>
</template>
<script>
import $ from '../../../static/js/jquery.min.js';
import axios from 'axios';
import qs from 'qs';
import Clipboard from "clipboard";

export default {
    name: 'fklist',
    data () {
        return {
            listArr: [],
            shopId: "",
            typeId: "",
            pageSize: 10, // 每次请求的数量
            pageNum: 1, // 页码 
            brandIndex: 1, 
            allLoaded: false,
            more: false,
            showBox: 1,

            shopId: "",
            appType: "", //app类型
            ryUserId: "", //融云id
            cityId: "",
            telNum: "",

            customer: "", //顾问信息

            showPhoneXS: false,

            customer: "",

            typeNum: "",

            defaultImg: 'this.src="' + require("../../../static/images/shopDetail/consultant2.png") + '"',

            urlType: "",

        }
    },

    computed:{

    },
    updated(){

    },
    methods:{

        indexFun(index){
            if(index == 0){
                return true;
            }else if(this.listArr[index].create_time != this.listArr[index-1].create_time){
                return true;
            }else{
                return false;
            } 
        },

        listData() {

            // alert(pageNum);
            let _this = this;
            let url = _this.changeData() + '/transfer/seeMemberList'
            axios(url,{
                method: 'post',
                params:{
                    id: this.shopId,
                    pageSize: this.pageSize, // 每页展示数量
                    pageNum: 1, // string  是   当前页
                    type: this.typeId, //0 访客列表 1智能推荐
                    phone: this.paramPhone
                }
            }).then(data => {
                console.log(data);
                this.listArr = data.data.data;
                this.customer = data.data.customer;

                console.log(this.customer);


                if(this.listArr.length == 0){
                    this.showBox = 0;
                }else{
                    this.showBox = 1;
                }

            }).catch(err => {
                console.log(err)
            });
        },

        //下拉刷新
        // loadTop(){

        //     this.listData();
  
        // },

        //上拉加载
        loadBottom() {
            // var _this = this;
            this.brandIndex++;

            let _this = this;
            let url = _this.changeData() + '/transfer/seeMemberList'
            axios(url,{
                method: 'post',
                params:{
                    id: this.shopId,
                    pageSize: this.pageSize, // 每页展示数量
                    pageNum: this.brandIndex, // string  是   当前页
                    type: this.typeId, //0访客列表 1智能推荐
                    paramPhone: this.paramPhone
                }
            }).then(data => {

                // console.log(data);

                _this.listArr = _this.listArr.concat(data.data.data);

                // console.log(_this.listArr);                

                if(data.data.data == ''){
                    _this.allLoaded = true;
                }

                _this.$refs.loadmore.onBottomLoaded();

            }).catch(err => {
                console.log(err)
            });
        },

        handleBottomChange(){
            var that = this;
            if(this.allLoaded == true){
                this.more = true;
                setTimeout(function () {
                    that.more = false;
                },2000)
            }
        },

        back(){

            // this.$router.go(-1);

            // this.$router.push({path:"/zhuanpudetail", query:{shopid:this.shopId}});

            if(this.urlType){
                if(this.appType == 'ios'){
                    this.$router.push({path:"/shopreport", query:{app: "ios", userId: this.ryUserId, cityId: this.cityId, shopId:this.shopId,page:1}});
                }else{
                    this.$router.push({path:"/shopreport", query:{app: "android", userId: this.ryUserId, cityId: this.cityId, shopId:this.shopId,page:1}});
                }
                
            }else{
                if(this.appType == 'ios'){
                    this.$router.push({path:"/zhuanpudetail", query:{app: "ios", userId: this.ryUserId, cityId: this.cityId, paramPhone: this.paramPhone, shopId:this.shopId}});
                }else{
                    this.$router.push({path:"/zhuanpudetail", query:{app: "android", userId: this.ryUserId, cityId: this.cityId, paramPhone: this.paramPhone, shopId:this.shopId}});
                }
            }
        },

        // 跳转IM
        goMessageuser(){

            alert(this.typeId);


            let _this = this;

            if(this.typeId == '0'){

                this.typeNum = '0_3';

            }else{

                this.typeNum = '0_4';

            }

            // layer.open({
            //     content: this.typeNum,
            //     skin: "msg",
            //     time: 2 //2秒后自动关闭
            //   });

            let url = _this.changeData() + '/message/sendCustomeTipsOrShop'
            axios(url,{
                method: 'post',
                params:{
                    senderId: this.ryUserId, //发送人ID
                    targetIds: this.customer.id, //接收人ID
                    shopId: this.shopId, //商铺ID
                    type: this.typeNum,
                    // source: "1",//  string  是   触发来源 1：详情 2：推荐
                }
            }).then(data => {

                console.log(data);
                 
            }).catch(err => {
                console.log(err)
            });



            if(this.appType == "ios"){

                window.webkit.messageHandlers.currentCookies.postMessage({
                    "body": "buttonActionMessage"
                });

            }
        },
        
        // 拨打电话
        telPhone(){

            if(this.appType == "ios"){

                window.location.href = "tel:" + this.customer.phone;

            }

        },

        copyDel () {
          var clipboard = new Clipboard('.order-id') //绑定数据标签的类名
              clipboard.on('success', e => {
                // console.log('复制成功', e)
                // alert('复制成功');

                layer.open({
                    content: "复制成功",
                    skin: "msg",
                    time: 2 //2秒后自动关闭
                });

                // 释放内存
                clipboard.destroy()
              })
              clipboard.on('error', e => {
                // alert('该浏览器或手机权限不支持复制功能');
                layer.open({
                    content: "该浏览器或手机权限不支持复制功能",
                    skin: "msg",
                    time: 2 //2秒后自动关闭
                });
                // 释放内存
                clipboard.destroy()
              })
        },


  
    },
    mounted() {

        this.shopId = this.$route.query.shopId;
        this.typeId = this.$route.query.type;


        this.appType = this.$route.query.app;

        this.ryUserId = this.$route.query.userId;

        // this.shopId = this.$route.query.shopId;

        this.cityId = this.$route.query.cityId;

        this.paramPhone = this.$route.query.paramPhone;

        this.urlType = this.$route.query.url;

        // this.telNum = this.$route.query.tel;



        // iPhone X、iPhone XS
        var isIPhoneX = /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 3 && window.screen.width === 375 && window.screen.height === 812;
        // iPhone XS Max
        var isIPhoneXSMax = /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 3 && window.screen.width === 414 && window.screen.height === 896;
        // iPhone XR
        var isIPhoneXR = /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 2 && window.screen.width === 414 && window.screen.height === 896;

        if(this.appType == "ios"){
            if(isIPhoneX || isIPhoneXSMax || isIPhoneXR){
                this.showPhoneXS = true;

                $(".fklist-top").css({ "padding-top": ".88rem" });

                // $(".fklist-list").css({ "padding-top": "2.98rem" });
            }
        }

        this.listData();

        // console.log(this.shopId);
 
    },
    created() { 

       
    }
}
</script>


<style scoped lang="scss">
.fklist{
    width: 7.5rem;
    height: 90vh;
    background: #fff;
}
.fklist-top{
    width: 7.5rem;
    height: 1.1rem; 
    border-bottom: 1px solid #f2f2f2;
    text-align: center;
    font-size: .36rem;
    font-weight: 400;
    color: #0f1923;
    line-height: 1.1rem;
    position: fixed;
    left: auto;
    top: 0;
    background: #fff;
    z-index: 9;
    .navBack{
        width: .2rem;
        height: .33rem;
        position: absolute;
        left: .4rem;
        bottom: .38rem;
    }
}
.fklist-list{
    width: 6.7rem;
    padding: 1.1rem .4rem 2.2rem;
    background: #fff;
    dl{
        width: 6.7rem;
        position: relative;
        border-bottom: 1px solid #f7f7f7;
        p{
            font-size: .26rem;
            font-weight: 400;
            color: #999;
            line-height: .38rem;
            padding-top: .6rem;
            span{

            }
        }
        dt{
            padding: .3rem 0;
            img{
                width: .84rem;
                height: .84rem;
                border-radius: 50%;
                border: none;
            }
            .span1{
                font-size: .32rem;
                font-weight: 400;
                color: #0f1923;
                line-height: .46rem;
            }
            p{
                font-size: .32rem;
                font-weight: 400;
                color: #0f1923;
                line-height: .46rem;
                -webkit-tap-highlight-color: rgba(0,0,0,0);
                display: inline-block;
                span{
                    font-size: .28rem;
                    font-weight: 500;
                    color: #4990e2;
                    line-height: .46rem;
                    -webkit-tap-highlight-color: rgba(0,0,0,0);
                    margin-left: .2rem;
                }
            }
        }
        dd{
            font-size: .26rem;
            font-weight: 400;
            color: #666;
            line-height: .38rem;
            position: absolute;
            right: 0rem;
            bottom: .53rem;
        }
    }
}

/* footer */
.shopdetail-footer{
    width: 6.5rem;
    padding: 0 .5rem;
    height: 1.68rem;
    background: #fff;
    position: fixed;
    left: auto;
    bottom: 0;
    border-bottom: 2px solid #f8f8f8;
    z-index: 1000;
    .consultant2-img{
        width: 1.58rem;
        height: 1.58rem;
        position: relative;
        left: 0;
        top: -.4rem;
        border-radius: 50%;
    }
    ul{
        float: right;
        margin-top: .2rem;
        li{
            width: 2.24rem;
            float: left;
            text-align: center;
            line-height: .8rem;
            font-size: .32rem;
            font-weight: 400;
            color: #fff;
            -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
            img{
                width: .36rem;
                height: .36rem;
            }
        }
        .li1{
            background: url("../../../static/images/shopDetail/footer1.png") no-repeat;
            background-size: 2.24rem .86rem;
        }
        .li2{
            background: url("../../../static/images/shopDetail/footer2.png") no-repeat;
            background-size: 2.24rem .86rem;
        }
    }
}

.noDataBottom{
    text-align: center;
    font-size: .3rem;
    line-height: 1rem;
}

/*无数据*/
.null-data-box{
    text-align: center;
    padding-top: 3rem;
    img{
        width: 1.6rem;
        height: 1.6rem;
    }
    p{
        font-size: .28rem;
        font-weight: 400;
        color: #999;
        line-height: .4rem;
        margin-top: .24rem;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/home/fklist.vue